"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function Report(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { className: className ? "icon ".concat(className) : "", height: "".concat(height), width: "".concat(width), viewBox: "0 0 39 52" },
        React.createElement("path", { d: "M13.3956 0.000244065H32.4405C32.9388 -0.00540797 33.4334 0.0871577 33.8959 0.272656C34.3585 0.458154 34.78 0.732951 35.1363 1.08135C35.4927 1.42976 35.7769 1.84494 35.9728 2.3032C36.1687 2.76146 36.2724 3.25382 36.278 3.75215V46.7779C36.2742 47.2755 36.1723 47.7676 35.978 48.2257C35.7836 48.6839 35.5007 49.0992 35.1455 49.4478C34.7903 49.7964 34.3698 50.0714 33.908 50.2571C33.4463 50.4427 32.9524 50.5354 32.4547 50.5298H3.82324C3.32678 50.5354 2.83406 50.4432 2.37323 50.2584C1.9124 50.0736 1.49248 49.7999 1.13746 49.4528C0.78243 49.1057 0.499248 48.6921 0.304081 48.2356C0.108915 47.7791 0.00558853 47.2886 0 46.7921V14.9651H9.61516C10.1128 14.9726 10.6071 14.8818 11.0695 14.6979C11.532 14.514 11.9536 14.2405 12.3102 13.8933C12.6667 13.546 12.9512 13.1317 13.1472 12.6743C13.3433 12.2168 13.4471 11.7251 13.4527 11.2274V0.000244065H13.3956ZM0.0142661 13.0963H9.61516C10.1159 13.0963 10.5964 12.8983 10.9518 12.5456C11.3072 12.1928 11.5087 11.7139 11.5125 11.2132V0.000244065L0.0142661 13.0963ZM17.2188 13.0963V14.9651H30.6002V13.0963H17.2188ZM17.2188 7.47553V9.34435H30.6002V7.4898H17.2188V7.47553ZM5.80619 18.7027V20.5715H30.6002V18.717H5.74912L5.80619 18.7027ZM5.80619 24.3235V26.1923H30.6002V24.3235H5.74912H5.80619ZM5.80619 29.9442V31.813H30.6002V29.9442H5.74912H5.80619ZM5.80619 35.5649V37.4337H30.6002V35.5649H5.74912H5.80619ZM5.80619 41.1856V43.0545H30.6002V41.1714H5.74912L5.80619 41.1856Z", fill: "white" })));
}
Report.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
Report.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = Report;
